<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Cliente vendedor</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Cliente vendedor</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="agregarClienteVendedor.show()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>

    <div class="row filtros-body">
      <div class="col" style="max-width: 300px">
        <div class="md-form mb-0">
          <input
            value=""
            type="text"
            id="rutCliente"
            class="form-control"
            placeholder="RUT"
            required
            #rutCliente
          />
          <label for="rutCliente">RUT Cliente</label>
        </div>
      </div>
      <div class="col d-flex">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarCliente.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents">Nombre del cliente</h6>
      </div>
    </div>

    <div class="row filtros-body">
      <div class="col" style="max-width: 200px">
        <div class="md-form mb-0">
          <mdb-select
            [options]="optionsSucursal"
            [multiple]="true"
            [filterEnabled]="true"
            [highlightFirst]="false"
            placeholder="Seleccionar sucursal"
          ></mdb-select>
          <label>Sucursal</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <mdb-select
            label="Comuna"
            [options]="optionsComuna"
            placeholder="Comuna"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <mdb-select
            label="Ciudad"
            [options]="optionsCiudad"
            placeholder="Ciudad"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <mdb-select
            label="Territorio"
            [options]="optionsTerritorio"
            placeholder="Territorio"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
    </div>

    <div class="row filtros-body">
      <div class="col" style="max-width: 500px">
        <div class="md-form">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="direccion"
              class="form-control"
              placeholder="Dirección"
              required
              #direccion
            />
            <label for="direccion">Dirección</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <div></div>
    <button mdbBtn color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Vendedor</th>
            <th scope="col" class="text-center">L</th>
            <th scope="col" class="text-center">M</th>
            <th scope="col" class="text-center">M</th>
            <th scope="col" class="text-center">J</th>
            <th scope="col" class="text-center">V</th>
            <th scope="col" class="text-center">S</th>
            <th scope="col" class="text-center">D</th>
            <th scope="col" class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
        
            <td>Juan Perez</td>
            <td class="text-center">
              <mdb-icon far icon="check-square"></mdb-icon>
            </td>
            <td class="text-center">
              <mdb-icon far icon="square"></mdb-icon>
            </td>

            <td class="text-center">
              <mdb-icon far icon="square"></mdb-icon>
            </td>

            <td class="text-center">
              <mdb-icon far icon="square"></mdb-icon>
            </td>

            <td class="text-center">
              <mdb-icon far icon="square"></mdb-icon>
            </td>

            <td class="text-center">
              <mdb-icon far icon="check-square"></mdb-icon>
            </td>

            <td class="text-center">
              <mdb-icon far icon="check-square"></mdb-icon>
            </td>

            <td>
              <button
                mdbBtn
                type="button"
                size="sm"
                color="primary"
                mdbWavesEffect
                class="btn-actions-sm"
              >
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar Cliente vendedor-->
<div
  mdbModal
  style="overflow-y: auto"
  #agregarClienteVendedor="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="agregarClienteVendedor.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del Cliente vendedor
                </h5>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col" style="max-width: 150px">
                <div class="md-form">
                  <input
                    value=""
                    type="text"
                    id="rutvende"
                    class="form-control"
                    placeholder="9.999.999-9"
                    required
                    #rutvende
                  />
                  <label for="rutvende">RUT vendedor</label>
                </div>
              </div>
              <div class="col d-flex" style="max-width: 300px">
                <button
                  mdbBtn
                  type="button"
                  class="btn-cuadrado"
                  color="secondary"
                  mdbWavesEffect
                  (click)="seleccionarVendedor.show()"
                >
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" style="display: contents">
                  Nombre de vendedor
                </h6>
              </div>
            </div>

            <div
              class="row filtros-body"
              style="border-bottom: 1px solid #dee2e6"
            >
              <div class="col">
                <h5>IPT</h5>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mdb-checkbox>Lunes </mdb-checkbox>
              </div>
              <div class="col"><mdb-checkbox>Martes </mdb-checkbox></div>
              <div class="col"><mdb-checkbox>Miercoles </mdb-checkbox></div>
              <div class="col"><mdb-checkbox>Jueves </mdb-checkbox></div>
              <div class="col"><mdb-checkbox>Viernes </mdb-checkbox></div>
              <div class="col"><mdb-checkbox>Sábado </mdb-checkbox></div>
              <div class="col"><mdb-checkbox>Domingo </mdb-checkbox></div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="agregarClienteVendedor.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="button"
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            type="submit"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<div
  mdbModal
  #seleccionarCliente="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar cliente
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarCliente.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="nombreProduct"
                class="form-control"
                placeholder="Nombre o RUT del cliente"
                required
                #nombreProduct
              />
              <label for="nombreProduct">Nombre o RUT del cliente</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button
              mdbBtn
              type="button"
              class="btn-cuadrado"
              color="secondary"
              mdbWavesEffect
              (click)="seleccionarCliente.show()"
            >
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center" class="text-center">RUT</th>
              <th scope="col" class="text-center" class="text-center">
                Nombre
              </th>
              <th scope="col" class="text-center" class="text-center">
                Sucursal
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarCliente.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarCliente.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarCliente.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<div
  mdbModal
  #seleccionarVendedor="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar vendedor
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarVendedor.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="rutVend"
                class="form-control"
                placeholder="Nombre o RUT del vendedor"
                required
                #rutVend
              />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button
              mdbBtn
              type="button"
              class="btn-cuadrado"
              color="secondary"
              mdbWavesEffect
              (click)="seleccionarVendedor.show()"
            >
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarVendedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarVendedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarVendedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
